import Icon from "../Icon";
import { etiquetaDia } from "./planes";

// Las propuestas que me han hecho y aun no ha aprobado un gestor (T-135/T-136): se ven, marcadas, pero no se planifican, no se
// hacen y no se cronometran hasta que se aprueben, y todavia no cuentan en mi carga. Solo queda la conversacion.
export default function PropuestasRecibidas({ items = [], miId, onHilo }) {
  if (!items.length) return null;
  return (
    <section className="mt-propuestas" aria-label="Propuestas pendientes de aprobación">
      <div className="mt-prop-cab">Propuestas pendientes de aprobación <span>{items.length}</span></div>
      {items.map(t => {
        const mia = miId != null && String(t.enviada_por?.id) === String(miId);
        return (
          <div key={t.id} className="mt-fila prop">
            <div className="mt-cuerpo">
              <div className="mt-titulo">{t.titulo}</div>
              {t.encargo?.descripcion && <div className="mt-desc">{t.encargo.descripcion}</div>}
              <div className="mt-meta">
                <span className="mt-est pa">○ {mia ? "Propuesta tuya, pendiente de aprobación" : "Propuesta, pendiente de aprobación"}</span>
                {!mia && t.enviada_por && <span>Propuesta por {t.enviada_por.nombre}</span>}
                {t.fecha && <span>Límite {etiquetaDia(t.fecha)}</span>}
              </div>
              <div className="mt-sel-nota">
                {mia ? "Un gestor o administrador de tu equipo tiene que aprobarla." : "Todavía no cuenta en tu carga. Podrás planificarla y empezarla cuando se apruebe."}
              </div>
            </div>
            <div className="mt-acc">
              {onHilo && (
                <button type="button" className="mt-b btn" onClick={() => onHilo(t)}
                  aria-label={`Ver la conversación: ${t.titulo}${t.encargo?.mensajes_total ? `, ${t.encargo.mensajes_total} comentarios` : ""}`}>
                  <Icon name="chat-dots-fill" size={13} color="currentColor" />Conversación{t.encargo?.mensajes_total ? ` ${t.encargo.mensajes_total}` : ""}
                </button>
              )}
            </div>
          </div>
        );
      })}
    </section>
  );
}
